import React, { ReactNode, VFC } from 'react';
import styled from 'styled-components';
import T from 'i18n-react';
import MoreSeeLink from '../atoms/MoreSeeLink';
import CardsLineTitle from '../atoms/CardsLineTitle';

interface Props {
  title: ReactNode;
  subtitle?: ReactNode;
  linkProps?: {
    href: string;
    target?: string;
    rel?: string;
    'data-gtm'?: string;
  };
  children: ReactNode;
}
const CardsLineWrapper: VFC<Props> = ({
  title,
  subtitle,
  linkProps,
  children,
}: Props) => {
  return (
    <Wrapper className="container">
      <CardsLineTitle subtitle={subtitle}>{title}</CardsLineTitle>
      <div>{children}</div>
      {linkProps && (
        <MoreSeeLink linkProps={linkProps}>
          {T.translate('seeMore')}
        </MoreSeeLink>
      )}
    </Wrapper>
  );
};

export default CardsLineWrapper;

const Wrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(5)}px;
`;
